import { useCallback } from "react"
import Select, { SelectChangeEvent } from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import Box from "@mui/material/Box"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import { OK } from "helpers/data-statuses"
import type { DataStatus } from "helpers/data-statuses"
import OPTooltip from "components/material/tooltip"

import "./style.scss"

export interface ForecastMeta {
  id: string
  name: string
  description?: string
}

interface ForecastProps {
  forecast: string | undefined
  onChange: (value: string | undefined) => void
  forecasts: ForecastMeta[]
  forecastsStatus: DataStatus
  disableForecasts: boolean
}

export default function Forecast({ forecast, onChange, forecasts, forecastsStatus, disableForecasts }: ForecastProps) {
  const handleChange = useCallback((event: SelectChangeEvent<string>) => {
    const newValue = event.target.value
    onChange(newValue === "none" ? undefined : newValue)
  }, [onChange])
  const noForecasts = disableForecasts || forecastsStatus !== OK || !forecasts

  const formControl = (
    <FormControl className="forecast-select">
      <InputLabel id="forecast-select-label">Forecast</InputLabel>
      <Select
        labelId="forecast-select-label"
        id="select"
        value={disableForecasts ? "none" : forecast ?? "none"}
        onChange={handleChange}
        label="Forecast"
        autoWidth
        size="small"
        disabled={disableForecasts}
      >
        <MenuItem value="none">
          No Forecast
        </MenuItem>
        <MenuItem value="impliedReturns">
          Implied Returns
        </MenuItem>
        {!noForecasts && forecasts.map((forecast) => (
          <MenuItem key={forecast.id} value={forecast.id}>
            {forecast.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )

  return (
    <Box className="components_forecast">
      {disableForecasts ? (
        <OPTooltip title="Forecasts only available for portfolios">
          <span>{formControl}</span>
        </OPTooltip>
      ) : (
        formControl
      )}
    </Box>
  )
}
